export const filterFields = ['type'] as const;
